import "@/global.scss";
import "@/global";
import React from "react";
import PageView from "@/pages";
import GlobalTransition from "@/components/GlobalTransition";
import PullToRefresh from "@/components/PullToRefresh";
import { useStore } from "@/store";
import event, { EVENT_MAP } from "@/utils/event";
import { QueryClient, QueryClientProvider } from "react-query";
import { ConfigProvider } from "antd-mobile";
import zhCN from "antd-mobile/es/locales/zh-CN";
/**
 * @see https://mobile.ant.design/zh/guide/css-variables/#css-变量自动降级
 */
import "antd-mobile/bundle/css-vars-patch.css";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      // retryOnMount: false,
    },
  },
});

interface IAppProps {}
const App: React.FC<IAppProps> = () => {
  const { pullToRefreshEnabled } = useStore();

  const handleRefresh = async () => {
    event.emit(EVENT_MAP.LAYOUT__PULL_TO_REFRESH);
  };

  return (
    <React.Suspense fallback={<GlobalTransition />}>
      {/* @ts-ignore */}
      <QueryClientProvider client={queryClient}>
        <ConfigProvider locale={zhCN}>
          <PullToRefresh disabled={!pullToRefreshEnabled} onRefresh={handleRefresh}>
            <PageView />
          </PullToRefresh>
        </ConfigProvider>
      </QueryClientProvider>
    </React.Suspense>
  );
};

export default App;
